import { ShippingPolicy } from './ShippingPolicy';

export default ShippingPolicy;
